import {Box} from '@viptech/react-components'
import sub from 'date-fns/sub'
import moment from 'moment'
import {useEffect, useState} from 'react'
import {PaymentExpirationModal} from 'src/components/expirationDatePaymentModal/PaymentExpirationModal'
import {useAuth} from 'src/contexts/AuthContext'
import useNotificationPopUp from 'src/hooks/useNotificationPopUp'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {ContainerPaperContent} from 'src/layouts/main-layout/LayoutBase'
import {parseEventsUrlSearchParams} from 'src/lib/portal-migration/events-search-params-sync'
import {useWindowSize} from 'usehooks-ts'
import useEvents from '../../hooks/api/events/useEvents'
import {FilterEventsType, SearchEventsType} from '../../services/api/endpoints/EventsEndpoint'
import AlarmsGridTable from './components/alarms-table/AlarmsGridTable'
import {OfferAppBrain} from './components/offer-app-brain/OfferAppBrain'
import {TobBarHeader} from './components/top-bar/TobBarHeader'
import {useEventsUrlSync} from './hooks/use-events-url-sync.hook'

const START_DATE = moment(sub(new Date(), {minutes: 30})).format()
const FINAL_DATE = moment(new Date()).endOf('day').format()

function getInitialEventsStateFromUrl() {
  if (typeof window === 'undefined') return null
  return parseEventsUrlSearchParams(window.location.search)
}

function Events() {
  const urlState = getInitialEventsStateFromUrl()
  const {userB2cHasCompanyExpired, setUserB2cHasCompanyExpired, checkDueDateInB2cUserCompany, userIsB2c} = useAuth()

  const {selectedCompanies} = useCompaniesSelector()

  const {width} = useWindowSize()

  const [filter, setFilter] = useState<FilterEventsType>({
    companyIds: selectedCompanies.map((it) => it.id),
    statuses: urlState != null ? (urlState.filter.statuses ?? []) : ['DESPACHADO'],
    to: urlState?.filter.to ?? FINAL_DATE,
    from: urlState?.filter.from ?? START_DATE,
    eventTypeIds: urlState?.filter.eventTypeIds,
  })
  const [search, setSearch] = useState<SearchEventsType>(urlState?.search ?? ({} as SearchEventsType))

  useEventsUrlSync({filter, search})

  const {
    data: allEvents,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    webSocketConnectionStatus,
    forceConnect,
    forceDisconnect,
  } = useEvents({
    filters: {
      ...filter,
      companyIds: selectedCompanies.map((it) => it.id),
    },
    search,
  })

  useNotificationPopUp({allEvents})

  useEffect(() => {
    checkDueDateInB2cUserCompany()
  }, [])

  useEffect(() => {
    if (filter.to && filter.from) {
      const withoutMiliTo = new Date(filter.to).setMilliseconds(0)
      const withoutMiliNow = new Date().setMilliseconds(0)
      if (withoutMiliTo < withoutMiliNow) forceDisconnect()
    }
  }, [filter.to, filter.from])

  useEffect(() => {
    setFilter((prev) => ({...prev, companyIds: selectedCompanies.map((it) => it.id)}))
  }, [selectedCompanies])

  if (width <= 767 && userIsB2c) return <OfferAppBrain />

  return (
    <ContainerPaperContent>
      <TobBarHeader
        filter={filter}
        search={search}
        setSearch={setSearch}
        setFilter={setFilter}
        initialUrlState={urlState}
        webSocketConnectionStatus={webSocketConnectionStatus}
        forceConnect={forceConnect}
        forceDisconnect={forceDisconnect}
      />
      <Box style={{height: '73vh'}}>
        <AlarmsGridTable
          events={allEvents}
          isLoadingAlarms={isLoading}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </Box>

      <PaymentExpirationModal isOpen={userB2cHasCompanyExpired} onClose={() => setUserB2cHasCompanyExpired(false)} />
    </ContainerPaperContent>
  )
}

export default Events
